import type { Prototype } from "../prototype-types";

export const kasiaBedkowskiPrototypes: Prototype[] = [
  {
    id: "kb-checkout",
    name: "Checkout",
    path: "/kb/checkout",
    description:
      "Retailer checkout shipping address step with multi-brand order summary.",
    owner: "Kasia Bedkowski",
    createdAt: "2026-07-09",
    lastUpdated: "2026-07-09",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/daa29b9133235878f0c6f588a979dbb972026074ba436bf6b9e296564e1405ea.png",
    creationTool: "cursor",
  },
  {
    id: "kb-nested-radio-block-checkbox",
    name: "Nested Radio Block Checkbox",
    path: "/kb/nested-radio-block-checkbox",
    description:
      "Signup 'How did you hear about Faire?' radio list with an expandable Google AI option (checkbox selector) that reveals nested AI Overview/Voice/Text sub-choices, tinted with the same grey selected background used across the block.",
    owner: "Kasia Bedkowski",
    createdAt: "2026-07-30",
    lastUpdated: "2026-07-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/kb-nested-radio-block-checkbox.png",
    creationTool: "claude-code",
  },
  {
    id: "kb-nested-radio-block-dropdown",
    name: "Nested Radio Block Dropdown",
    path: "/kb/nested-radio-block-dropdown",
    description:
      "Signup 'How did you hear about Faire?' radio list with an expandable Google AI option (chevron dropdown selector) that reveals nested AI Overview/Voice/Text sub-choices with a plain, untinted expand.",
    owner: "Kasia Bedkowski",
    createdAt: "2026-07-30",
    lastUpdated: "2026-07-30",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/kb-nested-radio-block-dropdown.png",
    creationTool: "claude-code",
  },
  {
    id: "kb-foi-multi-brand-copy",
    name: "FOI Multi-Brand Copy",
    path: "/kb/foi-multi-brand-copy",
    description:
      "Cart, modal, and banner treatments that make the 50% welcome offer apply across brands in the first checkout, with one shared $100 cap.",
    owner: "Kasia Bedkowski",
    createdAt: "2026-08-31",
    lastUpdated: "2026-08-31",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    project: "First Order Incentive",
    thumbnail: "/images/thumbnails/kb-foi-multi-brand-copy.png",
    creationTool: "cursor",
  },
  {
    id: "kb-signup-congratulations",
    name: "Signup congratulations",
    path: "/kb/signup-congratulations",
    description:
      "Retailer signup congratulations after payment terms, with Text, Icons, and Checks variants.",
    owner: "Kasia Bedkowski",
    createdAt: "2026-09-03",
    lastUpdated: "2026-09-21",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/kb-signup-congratulations.png",
    creationTool: "cursor",
    figmaLink:
      "https://www.figma.com/design/c5oXap1cx1xjOuaXTQBOGY/Faire-Values?node-id=838-9213",
  },
];
